import {digg} from "diggerize"
import env from "shared/env"
import TagManager from "react-gtm-module"

const googleTagManagerId = digg(env, "GOOGLE_TAG_MANAGER_ID")

if (googleTagManagerId != "fake") {
  TagManager.initialize({gtmId: googleTagManagerId})
}
